import { render } from "./CartIcon.vue?vue&type=template&id=13674afa"
import script from "./CartIcon.vue?vue&type=script&lang=js"
export * from "./CartIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/nicky/htdocs/vuejs-tailwindcss-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__